const linkname={
    features:"features",
    about:"About Us",
    contact:"Contact",
    helpcenter:"Help Center",

    policy:"Privacy Policy",
    conditions:"Terms & Conditions",
    guidelines:"Community Guidelines",
    cookies:"cookies",
    guide:"User Guide",
    manual:"Manual"
}


export default linkname;

